import styled from 'styled-components';
import Container from '../Container';

export default styled(Container)`
  font-weight: 500;
  padding: 1rem;
`;
